var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useCallback } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { useFirebase } from '@web/firebase';
import { usePage, usePageEdit } from '../../';
import { BlockListSection } from '../../../ModuleBlock';
export var PageDragDrop = memo(function (_a) {
    var children = _a.children;
    var page = usePage().page;
    var addOrUpdatePage = useFirebase().addOrUpdatePage;
    var onPageChange = usePageEdit().onPageChange;
    var onBeforeDragStart = function () {
        console.log('::drag - before');
    };
    var onDragStart = function () {
        console.log('::drag - start');
    };
    var onDragUpdate = function () {
        console.log('::drag - update');
    };
    var reorder = function (list, startIndex, endIndex) {
        var result = Array.from(list);
        var removed = result.splice(startIndex, 1)[0];
        result.splice(endIndex, 0, removed);
        return result;
    };
    var move = function (source, destination, droppableSource, droppableDestination) {
        var sourceClone = Array.from(source);
        var destClone = Array.from(destination);
        var removed = sourceClone.splice(droppableSource.index, 1)[0];
        destClone.splice(droppableDestination.index, 0, removed);
        var result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;
        return result;
    };
    var add = function (draggableId, destination, droppableDestination) {
        var destClone = Array.from(destination);
        destClone.splice(droppableDestination.index, 0, draggableId);
        return destClone;
    };
    var onDragEnd = useCallback(function (result) {
        var _a, _b, _c;
        var destination = result.destination, source = result.source, draggableId = result.draggableId;
        var pageBlocks = __assign({}, page.data.blocks);
        if (!destination)
            return;
        var blocks;
        if (source.droppableId === destination.droppableId) {
            if (destination.droppableId !== BlockListSection) {
                var items = reorder(pageBlocks[source.droppableId], source.index, destination.index);
                blocks = __assign(__assign({}, pageBlocks), (_a = {}, _a[source.droppableId] = items, _a));
            }
        }
        else {
            if (destination.droppableId !== BlockListSection) {
                if (source.droppableId !== BlockListSection) {
                    var result_1 = move(pageBlocks[source.droppableId], pageBlocks[destination.droppableId], source, destination);
                    blocks = __assign(__assign({}, pageBlocks), (_b = {}, _b[source.droppableId] = result_1[source.droppableId], _b[destination.droppableId] = result_1[destination.droppableId], _b));
                }
                else {
                    var result_2 = add(draggableId, pageBlocks[destination.droppableId], destination);
                    blocks = __assign(__assign({}, pageBlocks), (_c = {}, _c[destination.droppableId] = result_2, _c));
                }
            }
        }
        if (destination.droppableId !== BlockListSection) {
            onPageChange({ data: { blocks: blocks } });
            addOrUpdatePage({ _id: page.data.id, data: { blocks: blocks } });
        }
    }, [addOrUpdatePage, page, onPageChange]);
    return (React.createElement(DragDropContext, { onBeforeDragStart: onBeforeDragStart, onDragStart: onDragStart, onDragUpdate: onDragUpdate, onDragEnd: onDragEnd }, children));
});
